import { TabData } from '@/__core/types/TabData';

export interface RelatedEntityTabRecord<T = unknown> {
  id: string;
  title: string;
  companyId?: string;
  data?: T;
}

interface OpenOrFocusEntityTabOptions<T> {
  tabs: TabData[];
  tabType: string;
  entityType: string;
  record: RelatedEntityTabRecord<T>;
  setActiveTab: (index: number) => void;
  openTab: (tab: TabData) => unknown;
  metadata?: Record<string, unknown>;
}

/** Shared pattern for relation tables that open entity details in the current module. */
export function openOrFocusEntityTab<T>({
  tabs,
  tabType,
  entityType,
  record,
  setActiveTab,
  openTab,
  metadata,
}: OpenOrFocusEntityTabOptions<T>): 'focused' | 'opened' {
  const existingIndex = tabs.findIndex(
    (tab) => tab.type === tabType && String(tab.entityId || '') === String(record.id)
  );
  if (existingIndex >= 0) {
    setActiveTab(existingIndex);
    return 'focused';
  }

  openTab({
    id: Date.now() + Math.floor(Math.random() * 1000),
    title: record.title || entityType,
    type: tabType,
    closable: true,
    entityId: record.id,
    entityType,
    entityData: record.data,
    createdAt: Date.now(),
    metadata: {
      companyId: record.companyId,
      ...metadata,
    },
  });
  return 'opened';
}
